import { Grid } from "@mui/material";
import PageTitle from "../components/PageTitle";
import certificationIconImg from "../assets/icons8-notizie-100.svg";
import complianceIconImg from "../assets/icons8-apri-cartella-100.svg";
import accreditationIconImg from "../assets/icons8-ok-100.svg";
import policyIconImg from "../assets/icons8-ventiquattrore-100.svg";
import fundedIconImg from "../assets/icons8-idea-100.svg";
import PageContent from "../components/PageContent";
import { useTranslation } from "react-i18next";
import AccreditationPageCard from "../components/AccreditationPageCard";

const AccreditationPage = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <PageTitle>{t("menu.accredcompl")}</PageTitle>
      <PageContent>
        <Grid container sx={{ alignItems: "center", justifyContent: "center" }} spacing={4}>
          <AccreditationPageCard text={t("accred.cert")} navigateToUrl="certifications/list" image={certificationIconImg}/>
          <AccreditationPageCard text={t("accred.compl")} navigateToUrl="compliance/list" image={complianceIconImg}/>
          <AccreditationPageCard text={t("accred.accred")} navigateToUrl="accreditations/list" image={accreditationIconImg}/>
          <AccreditationPageCard text={t("accred.policy")} navigateToUrl="policy/list" image={policyIconImg}/>
          <AccreditationPageCard text={t("accred.funded")} navigateToUrl="funded/list" image={fundedIconImg}/>
        </Grid>
      </PageContent>
    </>
  );
};

export default AccreditationPage;
